module.exports = __webpack_public_path__ + "img/partners18.e22d994e.png";